import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import getPromoStatus from 'Api/stock-promo/getPromoStatus';
import getPromoStatusResponse from './model/response/getPromoStatusResponse';

const useGetPromoStatus = () => {
  const { t } = useTranslation('host-stock-promo');
  return useQuery({
    queryKey: ['all-promo-status', t],
    queryFn: async () => {
      const response = await getPromoStatus();

      const result = getPromoStatusResponse(response, t);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetPromoStatus;
